import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {WarehouseService} from 'app/blocks/service/api/warehouse.service';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {IWarehouse} from 'app/blocks/model/warehouse.model';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {Warehouse} from 'app/blocks/model/warehouse.model';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';

@Injectable({
    providedIn: 'root'
})
export class WarehouseResource extends AbstractEntityResource<IWarehouse> {
    constructor(warehouseService: WarehouseService, router: Router) {
        super(
            Resource.WAREHOUSES,
            warehouseService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.WAREHOUSES, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.WAREHOUSES),
            (entity?) => new Warehouse(entity),
            (entity) => entity.code,
            'location_city'
        );
    }
}
